import { BrandTokens } from "../../../@tokens/BrandTokens";
import { GlobalTokens } from "../../../@tokens/GlobalTokens";

export const style: any = {
  theme: {
    backgroundColor: BrandTokens.NeutralColorHighPure,
    borderRadius: GlobalTokens.BorderRadiusLg,
    border: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.NeutralColorHighMedium}`,
    padding: GlobalTokens.SpacingInsetSizeSm,
    //minHeight: '320px'
  }
}